import { render } from "./UtmServiceParameter.vue?vue&type=template&id=66a4140a&scoped=true"
import script from "./UtmServiceParameter.vue?vue&type=script&lang=ts"
export * from "./UtmServiceParameter.vue?vue&type=script&lang=ts"

import "./UtmServiceParameter.vue?vue&type=style&index=0&id=66a4140a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-66a4140a"

export default script